"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceOtrDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const common_1 = require("./common");
/**
 * Space OTR Dataset.
 */
class SpaceOtrDataset extends common_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Validate Address on OTR
         *
         * @param params Use {@link OtrRequest} with data based on {@link AddressValidationTangleRequest}
         * @returns
         */
        this.validateAddress = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.ADDRESS_VALIDATION }));
        /**
         * Create Space
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceCreateTangleRequest}
         * @returns
         */
        this.create = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_CREATE }));
        /**
         * Join Space
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceJoinTangleRequest}
         * @returns
         */
        this.join = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_JOIN }));
        /**
         * Leave Space
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceLeaveTangleRequest}
         * @returns
         */
        this.leave = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_LEAVE }));
        /**
         * Add guardian
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceMemberUpsertTangleRequest}
         * @returns
         */
        this.addGuardian = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_ADD_GUARDIAN }));
        /**
         * Remove guardian
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceMemberUpsertTangleRequest}
         * @returns
         */
        this.removeGuardian = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_REMOVE_GUARDIAN }));
        /**
         * Accept Member
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceMemberUpsertTangleRequest}
         * @returns
         */
        this.acceptMember = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_ACCEPT_MEMBER }));
        /**
         * Block Member
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceMemberUpsertTangleRequest}
         * @returns
         */
        this.blockMember = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_BLOCK_MEMBER }));
        /**
         * Decline Member
         *
         * @param params Use {@link OtrRequest} with data based on {@link SpaceMemberUpsertTangleRequest}
         * @returns
         */
        this.declineMember = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.SPACE_DECLINE_MEMBER }));
    }
}
exports.SpaceOtrDataset = SpaceOtrDataset;
